import styled from "styled-components"
import { Link } from "react-router-dom"
import { smallScreen } from "../../Responsive"

export const Container = styled.div`
    display: flex;
    width: 100%;
    max-width: 800px;

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontXS);
    }
`

export const StyledLink = styled(Link)`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    color: var(--secondary);
    transition: all 0.5s ease;
    
    &:hover{
        color: var(--primary);
        transform: scale(1.1);
    }
`